import {
    FETCH_INGREDIENTS,
    FETCH_INGREDIENT_DETAIL,
    CREATE_INGREDIENT,
    UPDATE_INGREDIENT,
    DELETE_INGREDIENT,
    FETCH_PENDING_INGREDIENTS,
    APPROVE_INGREDIENT,
    REJECT_INGREDIENT,
    PROMOTE_INGREDIENT,
    SET_INGREDIENT_FILTERS,
    CLEAR_INGREDIENT_DETAIL,
    SET_SELECTED_INGREDIENT,
} from './actions';

const initialState = {
    // List of ingredients
    list: [],
    listLoading: false,
    listError: null,

    // Ingredient detail
    detail: null,
    detailLoading: false,
    detailError: null,

    // Pending ingredients (admin)
    pendingList: [],
    pendingLoading: false,
    pendingError: null,

    // Create/Update/Delete
    creating: false,
    createError: null,
    updating: false,
    updateError: null,
    deleting: false,
    deleteError: null,

    // UI state
    filters: {},
    selectedIngredient: null,
};

export const ingredientsReducer = (state = initialState, action) => {
    switch (action.type) {
        // ==================== FETCH INGREDIENTS ====================
        case FETCH_INGREDIENTS.REQUEST:
            return {
                ...state,
                listLoading: true,
                listError: null,
            };

        case FETCH_INGREDIENTS.SUCCESS:
            return {
                ...state,
                listLoading: false,
                list: action.payload,
            };

        case FETCH_INGREDIENTS.FAILURE:
            return {
                ...state,
                listLoading: false,
                listError: action.payload,
            };

        // ==================== FETCH INGREDIENT DETAIL ====================
        case FETCH_INGREDIENT_DETAIL.REQUEST:
            return {
                ...state,
                detailLoading: true,
                detailError: null,
            };

        case FETCH_INGREDIENT_DETAIL.SUCCESS:
            return {
                ...state,
                detailLoading: false,
                detail: action.payload,
            };

        case FETCH_INGREDIENT_DETAIL.FAILURE:
            return {
                ...state,
                detailLoading: false,
                detailError: action.payload,
            };

        case CLEAR_INGREDIENT_DETAIL:
            return {
                ...state,
                detail: null,
                detailError: null,
            };

        // ==================== CREATE INGREDIENT ====================
        case CREATE_INGREDIENT.REQUEST:
            return {
                ...state,
                creating: true,
                createError: null,
            };

        case CREATE_INGREDIENT.SUCCESS:
            return {
                ...state,
                creating: false,
                list: [...state.list, action.payload],
                selectedIngredient: action.payload,
            };

        case CREATE_INGREDIENT.FAILURE:
            return {
                ...state,
                creating: false,
                createError: action.payload,
            };

        // ==================== UPDATE INGREDIENT ====================
        case UPDATE_INGREDIENT.REQUEST:
            return {
                ...state,
                updating: true,
                updateError: null,
            };

        case UPDATE_INGREDIENT.SUCCESS:
            return {
                ...state,
                updating: false,
                list: state.list.map(ing =>
                    ing.id === action.payload.id ? action.payload : ing
                ),
                detail: state.detail?.id === action.payload.id ? action.payload : state.detail,
            };

        case UPDATE_INGREDIENT.FAILURE:
            return {
                ...state,
                updating: false,
                updateError: action.payload,
            };

        // ==================== DELETE INGREDIENT ====================
        case DELETE_INGREDIENT.REQUEST:
            return {
                ...state,
                deleting: true,
                deleteError: null,
            };

        case DELETE_INGREDIENT.SUCCESS:
            return {
                ...state,
                deleting: false,
                list: state.list.filter(ing => ing.id !== action.payload.ingredientId),
                detail: state.detail?.id === action.payload.ingredientId ? null : state.detail,
            };

        case DELETE_INGREDIENT.FAILURE:
            return {
                ...state,
                deleting: false,
                deleteError: action.payload,
            };

        // ==================== FETCH PENDING INGREDIENTS ====================
        case FETCH_PENDING_INGREDIENTS.REQUEST:
            return {
                ...state,
                pendingLoading: true,
                pendingError: null,
            };

        case FETCH_PENDING_INGREDIENTS.SUCCESS:
            return {
                ...state,
                pendingLoading: false,
                pendingList: action.payload,
            };

        case FETCH_PENDING_INGREDIENTS.FAILURE:
            return {
                ...state,
                pendingLoading: false,
                pendingError: action.payload,
            };

        // ==================== APPROVE INGREDIENT ====================
        case APPROVE_INGREDIENT.SUCCESS:
            return {
                ...state,
                list: state.list.map(ing =>
                    ing.id === action.payload.id ? action.payload : ing
                ),
                pendingList: state.pendingList.filter(ing => ing.id !== action.payload.id),
            };

        // ==================== REJECT INGREDIENT ====================
        case REJECT_INGREDIENT.SUCCESS:
            return {
                ...state,
                list: state.list.map(ing =>
                    ing.id === action.payload.id ? action.payload : ing
                ),
                pendingList: state.pendingList.filter(ing => ing.id !== action.payload.id),
            };

        // ==================== PROMOTE INGREDIENT ====================
        case PROMOTE_INGREDIENT.SUCCESS:
            return {
                ...state,
                list: state.list.map(ing =>
                    ing.id === action.payload.id ? action.payload : ing
                ),
                pendingList: state.pendingList.filter(ing => ing.id !== action.payload.id),
            };

        // ==================== UI STATE ====================
        case SET_INGREDIENT_FILTERS:
            return {
                ...state,
                filters: action.payload,
            };

        case SET_SELECTED_INGREDIENT:
            return {
                ...state,
                selectedIngredient: action.payload,
            };

        default:
            return state;
    }
};

export default ingredientsReducer;
